import React, { useContext } from 'react';
import { DetailsInfoType } from './MapPage.types';
import { GeoJSON } from 'leaflet';
import { Marker } from 'react-leaflet';
import { clusterIcon } from '../../../components/Map/ReducedMap/Icons';
import { RType } from '../../../../types/vehicles';
import { transportSelectedMarkerIcon } from 'views/components/Video/MapComponent/icons';
import { setRouteTypeColors } from 'consts/vehicles';
import { mapContext } from './mapContext';
import { VehicleCluster } from 'views/components/VehicleCluster';

export const Cluster: React.FC = () => {
  const {
    clusters,
    mapSettings: { handleChangeMapSettings, mapSettings },
    layers,
    setDetailsInfo,
  } = useContext(mapContext);

  if (!layers.VEHICLES.active) return null;

  return (
    <>
      {clusters.map((cluster, index) => (
        <VehicleCluster
          key={index + JSON.stringify(cluster)}
          mapSettings={mapSettings}
          cluster={cluster}
          onChangeMapSettings={handleChangeMapSettings}
          onSelectVehicle={(id) =>
            setDetailsInfo({
              type: DetailsInfoType.vehicle,
              id,
            })
          }
        />
      ))}
    </>
  );
};
